import classnames from 'classnames';
import * as React from 'react';
import '../form_message/index.js';
import '../form_required_indicator/index.js';
import '../stack/index.js';
import '../visually_hidden/index.js';
import { formRow, inner, label, labelOffset, inline, disabled, invalid } from './form_row.css.js';
import { Stack } from '../stack/stack.js';
import { FormMessage } from '../form_message/form_message.js';
import { FormRequiredIndicator } from '../form_required_indicator/form_required_indicator.js';
import { VisuallyHidden } from '../visually_hidden/visually_hidden.js';

/**
 * Layout helper for form components. Internal use only.
 */
const FormRow = ({ label, labelClassName, labelId, labelPosition = 'block', onLabelClick, invalid: propsInvalid = false, disabled = false, required = false, labelOffset = 'none', className, helpMessage, helpMessageId, errorMessage, errorMessageId, messagesPosition = 'after', id, role = 'default', children, ...rest }) => {
    const invalid = propsInvalid || !!errorMessage;
    const isFieldset = role === 'fieldset' || role === 'radiogroup';
    const gap = React.useMemo(() => {
        if (labelPosition === 'inline') {
            return 'small';
        }
        return 'xsmall';
    }, [labelPosition]);
    const messages = (helpMessage || errorMessage) && (React.createElement(Stack, { gap: "xsmall", direction: "column" },
        helpMessage && helpMessageId && (React.createElement(FormMessage, { kind: "help", id: helpMessageId }, helpMessage)),
        errorMessage && errorMessageId && (React.createElement(FormMessage, { kind: "error", id: errorMessageId }, errorMessage))));
    return (React.createElement(Stack, { ...rest, as: isFieldset ? 'fieldset' : 'div', role: role === 'radiogroup' ? 'radiogroup' : undefined, gap: gap, direction: labelPosition === 'inline' ? 'row' : 'column', alignItems: labelPosition === 'inline' ? 'start' : undefined, wrap: false, className: classnames(formRow, className) },
        React.createElement(FormRowLabel, { className: labelClassName, id: id, label: label, labelId: labelId, labelOffset: labelOffset, labelPosition: labelPosition, onClick: onLabelClick, required: required, invalid: invalid, disabled: disabled, role: isFieldset ? 'legend' : 'label' }),
        React.createElement(Stack, { gap: "small", direction: "column", className: inner },
            messagesPosition === 'before' ? messages : undefined,
            children,
            messagesPosition === 'after' ? messages : undefined)));
};
const FormRowLabel = ({ className: classNameProp, id, label: label$1, labelId, labelOffset: labelOffset$1 = 'none', labelPosition = 'block', onClick, required, invalid: invalid$1, disabled: disabled$1, role = 'label', }) => {
    const className = classnames(label, labelOffset[labelOffset$1], {
        [invalid]: invalid$1,
        [disabled]: disabled$1,
        [inline]: labelPosition === 'inline',
    }, classNameProp);
    const labelElement = label$1 && id ? (React.createElement("label", { className: className, id: labelId, htmlFor: id, onClick: onClick },
        label$1,
        required && React.createElement(FormRequiredIndicator, null))) : null;
    if (role === 'legend') {
        return (React.createElement(React.Fragment, null,
            React.createElement(VisuallyHidden, { as: "legend" }, label$1),
            labelPosition !== 'hidden' && (React.createElement("div", { "aria-hidden": "true", className: className, onClick: onClick },
                label$1,
                required && React.createElement(FormRequiredIndicator, null)))));
    }
    if (labelPosition === 'hidden') {
        return React.createElement(VisuallyHidden, null, labelElement);
    }
    return labelElement;
};

export { FormRow };
